import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/api'
import { DEFAULT_CLIENT_UI } from '@/lib/client-ui'
import { useAuthStore } from '@/stores/auth'
import type { ClientUiConfig, PageKey } from '@/types/api'

/**
 * 用戶端 UI 編排配置。
 * 讀取失敗或尚未載入時退回內建預設——app 永遠渲染得出完整導航。
 */
export function useClientUiConfig(): { config: ClientUiConfig; isLoading: boolean } {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  const { data, isLoading } = useQuery({
    queryKey: ['client-ui-config'],
    queryFn: () => apiClient.getClientUiConfig(),
    staleTime: 5 * 60 * 1000,
    enabled: isAuthenticated,
    retry: 1,
  })

  return { config: data ?? DEFAULT_CLIENT_UI, isLoading }
}

/** 某個頁面是否被 admin 關閉（缺項視為開啟） */
export function usePageEnabled(pageKey: PageKey): boolean {
  const { config } = useClientUiConfig()
  return config.pages[pageKey]?.enabled !== false
}
